var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { useEffect, useState } from "react";
import { generatePath, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { CheckoutSummary, } from "@components/student/CheckoutSummary";
import { siteConcert, siteEvents, studentCheckoutThanks } from "@urls";
import { individualScheduleVar, selectedEventVar, trialLessonVar, } from "@local-state/vars";
import { useCreateConcertPurchaseMutation, useCreateEventPurchaseMutation, useCreateLessonPurchaseOrderMutation, useCreateLessonPurchaseOrderWithoutScheduleMutation, } from "@graphql";
export const CheckoutSummaryContainer = props => {
    const { schedule, subscriptionId, promocodeId } = props;
    const history = useHistory();
    const [createLessonPurchaseOrder] = useCreateLessonPurchaseOrderMutation();
    const [createEventPurchase] = useCreateEventPurchaseMutation();
    const [createConcertPurchase] = useCreateConcertPurchaseMutation();
    const [createLessonPurchaseOrderWithoutSchedule] = useCreateLessonPurchaseOrderWithoutScheduleMutation();
    const [paymentData, setPaymentData] = useState();
    const returnUrl = `${window.location.origin}${studentCheckoutThanks}`;
    useEffect(() => {
        if (!schedule)
            return;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f;
            try {
                let wfpDataString;
                if ("lessonTemplatesIds" in schedule) {
                    const { data } = yield createLessonPurchaseOrder({
                        variables: {
                            returnUrl,
                            lessonTemplatesIds: schedule.lessonTemplatesIds,
                            lessonSubscriptionId: subscriptionId,
                            promocodeId,
                        },
                    });
                    wfpDataString = (_a = data === null || data === void 0 ? void 0 : data.createLessonPurchaseOrder) === null || _a === void 0 ? void 0 : _a.data;
                }
                else if ("eventId" in schedule) {
                    try {
                        const { data } = yield createEventPurchase({
                            variables: {
                                email: schedule.email,
                                eventId: schedule.eventId,
                                firstName: schedule.firstName,
                                lastName: schedule.lastName,
                                phoneNumber: schedule.phoneNumber,
                                returnUrl: schedule.returnUrl || returnUrl,
                                tgOrInst: schedule.tgOrInst,
                            },
                        });
                        wfpDataString = (_b = data === null || data === void 0 ? void 0 : data.createEventPurchase) === null || _b === void 0 ? void 0 : _b.data;
                    }
                    catch (error) {
                        if ((_c = error.message) === null || _c === void 0 ? void 0 : _c.includes("Key (phone_number)=")) {
                            toast("Цей номер вже використаний!", { type: "error" });
                        }
                        else {
                            toast("Помилка при покупці квитка", { type: "error" });
                        }
                        history.push(siteEvents);
                        return;
                    }
                }
                else if ("concertId" in schedule) {
                    try {
                        const { data } = yield createConcertPurchase({
                            variables: {
                                concertId: schedule.concertId,
                                placeIds: schedule.placeIds,
                                email: schedule.email,
                                phoneNumber: schedule.phoneNumber,
                                expireTime: "00:10:00",
                                returnUrl: schedule.returnUrl || returnUrl,
                            },
                        });
                        wfpDataString = (_d = data === null || data === void 0 ? void 0 : data.createConcertPurchase) === null || _d === void 0 ? void 0 : _d.data;
                    }
                    catch (error) {
                        if ((_e = error.message) === null || _e === void 0 ? void 0 : _e.includes("Key (phone_number)=")) {
                            toast("Цей номер вже використаний!", { type: "error" });
                        }
                        else {
                            toast("Помилка при покупці квитка", { type: "error" });
                        }
                        history.push(generatePath(siteConcert, { concertId: schedule.concertId }));
                        return;
                    }
                }
                else {
                    const { data } = yield createLessonPurchaseOrderWithoutSchedule({
                        variables: {
                            returnUrl,
                            lessonSubscriptionId: subscriptionId,
                            promocodeId,
                        },
                    });
                    wfpDataString = (_f = data === null || data === void 0 ? void 0 : data.createLessonPurchaseOrderWithoutSchedule) === null || _f === void 0 ? void 0 : _f.data;
                }
                if (wfpDataString) {
                    setPaymentData(JSON.parse(wfpDataString));
                }
            }
            catch (err) {
                console.error("Checkout error:", err);
                toast("Сталася помилка під час створення замовлення", {
                    type: "error",
                });
            }
        }))();
    }, [schedule, subscriptionId]);
    useEffect(() => {
        return () => {
            individualScheduleVar([]);
            trialLessonVar([]);
            selectedEventVar(undefined);
        };
    }, []);
    return React.createElement(CheckoutSummary, Object.assign({}, props, { paymentData: paymentData }));
};
